/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useAddPayer
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { getOnboardingHeaders } from 'hooks/admin/useRegisteredPayers';
import { invalidateMetadata } from 'app-constants/queryKeys';

/**
 * Mutate for add payer
 *
 */
const useAddPayer = (
	onBoarding?: boolean,
): UseMutationResult<Payers.ISelectedPayerDetails, IAxiosError, Payers.IPayerAddModel, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			const { data } = await api.PayersApi.postPayer({ payerAddModel: model }, getOnboardingHeaders(onBoarding));
			return data;
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useAddPayer;
